import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import '../../../../../../components/AddMicroEventsModal/AddMicroEvents.scss';
import {
  admin_area_settings_incident_observation_events_path,
  not_added_events_admin_area_settings_incident_observation_events_path,
} from '../../../../../../routes';
import { SearchBarContext } from '../../../../../../components/SearchBar';
import SearchBarRow from '../../../../../../components/SearchBar/SearchBarRow';
import MultiSelectionModal from '../../../util/MultiSelectionModal';

const PrimarySearchItems = () => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group" style={{ flex: 1 }}>
        <label>{intl.formatMessage({ id: 'events.description' })}</label>
        <input className="form-control" {...register('description')}></input>
      </div>
    </SearchBarRow>
  );
};

const AddObservationEventsModal = ({ incidentId }) => {
  const intl = useIntl();
  const columns = [
    {
      header: intl.formatMessage({ id: 'events.event-id' }),
      accessor: 'eventId',
    },
    {
      header: intl.formatMessage({ id: 'events.description' }),
      accessor: 'description',
    },
  ];

  return (
    <MultiSelectionModal
      id={incidentId}
      buttonText="admin-area.settings.incident.observation-event.add-observation-event"
      loadPath={not_added_events_admin_area_settings_incident_observation_events_path}
      addPath={admin_area_settings_incident_observation_events_path}
      cols={columns}
      primarySearchItems={<PrimarySearchItems />}
    />
  );
};

AddObservationEventsModal.propTypes = {
  incidentId: PropTypes.number.isRequired,
};

export default AddObservationEventsModal;
